import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';
import { initSentry } from './config/sentry';
import logger from './utils/logger';

// Initialize Sentry before rendering the app
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
serviceWorkerRegistration.register({
  onSuccess: () => {
    logger.info('[ServiceWorker] Registered successfully');
  },
  onUpdate: () => {
    logger.info('[ServiceWorker] New content available, please refresh');
  },
  onError: (error) => {
    logger.error('[ServiceWorker] Registration failed:', error);
  }
});
